// import Store from '@/store/index.js'
import Constant from '@/const'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 料金納期検索
    calc({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.TRIAL}`,
        params: data,
        error: { message: '料金納期検索に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // 試用アカウント登録
    entry({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.TRIAL_ENTRY}`,
        params: data,
        error: { message: '試用アカウント登録に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
    // token簡易認証
    getUser({ commit, dispatch }, data) {
      const request = {
        url: `${Constant.API_URL.TRIAL_ACT_USER}`,
        params: data,
        error: { message: '試用アカウント登録に失敗しました。' },
      }
      return dispatch('http/post', { ...request }, { root: true }).catch(
        (err) => {
          throw new Error(err.message)
        }
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/trial.js